// Kept out of adFunctions.ts so the Assertive plugin and components can read
// them without pulling in the fallback renderers (and the specs that mock it).

// Instances the native fallback already destroyed, so the owning Assertive
// component skips its own destroy. The owner removes its code on unmount.
export const destroyedAyInstanceCodes = new Set<string>()

// Instances AY has refreshed on the current page. Cleared on changePage.
export const refreshedAyInstanceCodes = new Set<string>()

export type FallbackTracking = {
  ayInstanceCode: string
  adRefresh: boolean
}
